import './index.css';

function CallUsButton({ isMobileHeader = false }) {
  return (
    <div className="call-us-button-container">
      {isMobileHeader ? (
        <div className="header-call-link">
          <a href="tel:+61485026887">
            📱 0485 026 887
          </a>
          <span> / </span>
          <a href="tel:+61240480882">
            📞 (02) 4048 0882
          </a>
        </div>
      ) : (
        <div className="normal-call-link">
          <a href="tel:+61485026887">
            📱 0485 026 887
          </a>
          <span> / </span>
          <a href="tel:+61240480882">
            📞 (02) 4048 0882
          </a>
        </div>
      )}
    </div>
  );
}

export default CallUsButton;